import { IType } from '../internal';

export const boolean: IType = {
  name: 'boolean',
};
